import type {
  _WorkbookApi,
  WorkbookApi,
} from '@mathflat/domain/@entities/(Content)/Workbook/api'
import type { WorkbookDomain } from '@mathflat/domain/@entities/(Content)/Workbook/domain'

import { mpEventInfo } from '@/constant'
import type { Pagination } from '@/types'
import type { DefaultResponse } from '@/types'
import maxios, { type CustomRequestConfigMeta } from '@/utils/axios/maxios'

// 교재 API
/**
 * @deprecated
 */
const _workbookApi = {
  // 교재 검색
  getWorkbooks<
    T extends WorkbookDomain.Type,
    U extends 'GRADE' | 'CLASS' | 'STUDENT' | never = never,
  >(params: _WorkbookApi.Request.GetWorkbook<T, U>, meta?: CustomRequestConfigMeta) {
    return maxios.get<Pagination<_WorkbookApi.Response.GetWorkbook<T>[]>>(`/workbook`, {
      params: { ...params, mp_event_name: mpEventInfo.교재조회 },
      meta,
    })
  },
  // 교재 상세 정보 검색
  getWorkbookDetailInfo: (workbookId: number) => {
    return maxios.get<DefaultResponse<res.WorkbookDetailInfo>>(`/workbook/${workbookId}`, {
      params: { mp_event_name: mpEventInfo.교재수정시조회 },
    })
  },
  // 교재 센터 공유로 복제
  postWorkbookCopy: (workbookId: number, data: WorkbookApi.CopyCustomWorkbook.Request) => {
    return maxios.post<DefaultResponse<null>>(`/workbook/custom/${workbookId}/copy`, data)
  },
}

export default _workbookApi
